import template	from "./dialog-config.html";
import css		from "./dialog-config.css";

import Dialog	from "dialog";


class ConfigEZOCO2Dialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-ezoco2", ConfigEZOCO2Dialog);
  }
  constructor(...args) {
    super(...args);
    
    document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

    this.onupdatedevices_handler({detail: application.devices});

    this.show(...args);
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices.ezoco2Sensor.id;
    this.textboxDeviceStatus.value = devices.ezoco2Sensor.status;
    this.textboxValue.value = devices.ezoco2Sensor.value;
    this.textboxCalibrationStatus.value = devices.ezoco2Sensor.calibrationStatus;
  }  
  async buttonLowPointCalibration_click() {
    try {
      this.buttonLowPointCalibration.icon.iconname = "view-refresh";
      await server.rcall("RM_ezoco2_lowPointCalibration");
      this.buttonLowPointCalibration.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonLowPointCalibration.icon.iconname = "process-stop";
    }    
  }
  async buttonHighPointCalibration_click() {
    try {
      this.buttonHighPointCalibration.icon.iconname = "view-refresh";
      await server.rcall("RM_ezoco2_highPointCalibration", this.spinnerHighPoint.value);
      this.buttonHighPointCalibration.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonHighPointCalibration.icon.iconname = "process-stop";
    }     
  }
  async buttonClearCalibration_click() {
    try {
      this.buttonClearCalibration.icon.iconname = "view-refresh";
      await server.rcall("RM_ezoco2_clearCalibration");
      this.buttonClearCalibration.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonClearCalibration.icon.iconname = "process-stop";
    }     
  }
  buttonClose_click() {
    this.close();
  }
}

ConfigEZOCO2Dialog.constructor();

export default ConfigEZOCO2Dialog;